/**
 * BrandPainter — 2D fire mage silhouette (ember head).
 */
export const BrandPainter = {
  paint(ctx, _pos, radius, _entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.85, 0, Math.PI * 2);
    ctx.fillStyle = '#292524';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(0, -radius * 0.5, radius * 0.42, 0, Math.PI * 2);
    ctx.fillStyle = '#ea580c';
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(-radius * 0.25, -radius * 0.85);
    ctx.lineTo(0, -radius * 1.35);
    ctx.lineTo(radius * 0.25, -radius * 0.85);
    ctx.closePath();
    ctx.fillStyle = '#f97316';
    ctx.fill();
  }
};
